/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {issueAuthenticatedMoneybotSession} from '../api'

export const useMutationIssueAuthenticatedMoneybotSession = createReactQueryMutationHook('issueAuthenticatedMoneybotSession', issueAuthenticatedMoneybotSession)
